import React, { Fragment }  from "react";
import { TableCell, TableRow } from "@material-ui/core";
import { accessLevelDictionary } from "Shared/types/Admins";
import { LocationsTableCell } from "Components/Shared/LocationsTableCell/LocationsTableCell";
import { DPOperatingManager } from "Shared/types/OperatingManager";
import pretty from "Shared/pretty";
import { DPButton } from "Components/DP";

export interface OperatingManagersTableRowProps {
  manager: DPOperatingManager;
  canEditManagers: boolean;
  onEdit: (manager: DPOperatingManager) => void;
}

export const OperatingManagersTableRow = (props: OperatingManagersTableRowProps) => {
  const { manager, canEditManagers, onEdit } = props;
  const { employer, totalAmountCents, expectedApprovers } = manager;

  return (
    <TableRow>
      <TableCell>
        {pretty.fullName(employer.firstName!, employer.lastName!)}
      </TableCell>
      <TableCell>
        {accessLevelDictionary[employer.permissions]}
      </TableCell>
      <LocationsTableCell locations={employer.associatedLocations.items} />
      <TableCell>
        {pretty.dollar(totalAmountCents)}
      </TableCell>
      <TableCell>
        {expectedApprovers && expectedApprovers.map((approver, index) => (
          <Fragment key={approver.id}>
            {pretty.fullName(approver?.firstName || "", approver?.lastName || "")}
            {index !== expectedApprovers.length - 1 && <br/>}
          </Fragment>
        ))}
      </TableCell>
      {canEditManagers && (
        <TableCell>
          <DPButton onClick={() => { onEdit(manager); }} color="default">
            Edit
          </DPButton>
        </TableCell>
      )}
    </TableRow>
  );
};
